import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { AlertaDescarte } from '../_models/alerta-descarte';

@Injectable({
  providedIn: 'root'
})
export class AlertaDescarteService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/alertasDescartes';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as AlertaDescarte[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( `${this.rutServicio}/enabled` ).pipe( map( res => res as AlertaDescarte[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( `${this.rutServicio}/${id}` ).pipe( map( res => res as AlertaDescarte ) );
  }

  obtenerPorIdAlerta( id: string ) {
    return this.httClient.get( `${this.rutServicio}/alerta/${id}` ).pipe( map( res => res as AlertaDescarte ) );
  }

  crear( regCrear: AlertaDescarte ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as AlertaDescarte ) );
  }

  actualizar( regActualizar: AlertaDescarte ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( registros: AlertaDescarte[] ) {
    registros.forEach( r => r.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado() );
    return this.httClient.post( `${this.rutServicio}/bulk`, registros ).pipe( map( res => res as any ) );
  }
}
